module.exports = __webpack_public_path__ + "img/expand.e6dd5e1d.svg";